const modeNames = { CASH: '现金', BALANCE: '余额', XIAODUBI: '零售价', GIFT: '学费' }
const rewardNames = { BALANCE: '余额', XIAODUBI: '小杜币', GIFT: '学费' }
const statusNames = { 0: '待发放', 1: '已发放', 2: '已回退', 3: '发放失败', 4: '活动已失效' }

function json(value, fallback) {
  if (!value) return fallback
  if (typeof value === 'object') return value
  try { return JSON.parse(value) } catch (_) { return fallback }
}

function physical(type) { return !type || String(type).toUpperCase() === 'GOODS' }

// Rendering only: actual selected SKUs/counts come from the ledger, never from its candidate gift pool.
export function orderActivityRewards(records) {
  return (Array.isArray(records) ? records : []).filter(Boolean).map(record => {
    const parsed = json(record.ruleSnapshot, {})
    const snapshot = parsed && !Array.isArray(parsed) && typeof parsed === 'object' ? parsed : {}
    const condition = snapshot.condition || {}
    const activityName = snapshot.activityName || record.activityName || `活动${record.activityId || ''}`
    const mode = record.payModeName || modeNames[record.payMode] || record.payMode || '未记录'
    const status = record.statusName || statusNames[record.status] || '状态未记录'
    const type = String(record.rewardType || 'GOODS').toUpperCase()
    const candidates = Array.isArray(snapshot.gifts) ? snapshot.gifts : []
    const detail = json(record.rewardDetail, null)
    const gifts = physical(type) && Array.isArray(detail) ? detail.filter(item => item && item.skuId && Number(item.num) > 0).map(item => {
      const saved = candidates.find(candidate => candidate && String(candidate.skuId) === String(item.skuId)) || {}
      return { skuId: item.skuId, num: item.num, name: saved.goodsName || `赠品规格${item.skuId}`,
        spec: saved.spec || saved.specTitle || '规格未记录' }
    }) : []
    const rewardText = physical(type)
      ? (gifts.length ? gifts.map(item => `${item.name}（${item.spec}）×${item.num}件`).join('；') : '赠品明细未记录或无法读取')
      : `${record.rewardTypeName || rewardNames[type] || type} ${record.rewardValue == null ? '数量未记录' : record.rewardValue}`
    const threshold = condition.fullNum
    const ruleText = threshold > 0
      ? `满${threshold}${Number(snapshot.activityType) === 1 ? '件' : '元'}赠${physical(condition.rewardType) ? `${condition.giftNum == null ? '-' : condition.giftNum}件` : `${condition.rewardValue == null ? '-' : condition.rewardValue}${rewardNames[String(condition.rewardType).toUpperCase()] || ''}`}`
      : (snapshot.activityRule || '规则快照未记录')
    return { ...record, activityName, mode, status, rewardText, ruleText, gifts, pending: Number(record.status) === 0 }
  })
}
